export default "__VITE_PUBLIC_ASSET__fb4a2fe6__"